import React, { useRef, useEffect } from 'react';
import Editor from '@monaco-editor/react';
import MonacoJSXHighlighter from 'monaco-jsx-highlighter';
import { parse } from '@babel/parser';
import traverse from '@babel/traverse';
import './EditorCode.scss';

const EditorCode = ({
  value = '',
  children,
  onReset,
  onChange = () => {},
  id = 1
}) => {
  const editorRef = useRef(null);
  const modelUri = `file:///main.jsx/${id}`;

  const handleEditorDidMount = (editor, monaco) => {
    editorRef.current = editor;

    // Установка опций компиляции
    monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
      jsx: monaco.languages.typescript.JsxEmit.Preserve,
      target: monaco.languages.typescript.ScriptTarget.ESNext,
      allowNonTsExtensions: true,
      moduleResolution: monaco.languages.typescript.ModuleResolutionKind.NodeJs,
      module: monaco.languages.typescript.ModuleKind.ESNext,
      noEmit: true,
      esModuleInterop: true,
      allowJs: true,
    });

    const uri = monaco.Uri.parse(modelUri);

    // Проверяем, существует ли уже модель
    let model = monaco.editor.getModel(uri);
    if (!model) {
      model = monaco.editor.createModel(value, 'javascript', uri);
    }

    editor.setModel(model);

    // Подключение JSX Highlighter
    const babelParse = code =>
      parse(code, {
        sourceType: 'module',
        plugins: ['jsx'],
      });

    const highlighter = new MonacoJSXHighlighter(monaco, babelParse, traverse, editor);
    highlighter.highlightOnDidChangeModelContent(100);
    highlighter.addJSXCommentCommand();
  };

  useEffect(() => {
    return () => {
      // Можно удалять модель, если хочешь избежать повторов после размонтирования
      const monaco = require('monaco-editor');
      const model = monaco.editor.getModel(monaco.Uri.parse(modelUri));
      if (model && !model.isDisposed()) {
        model.dispose();
      }
    };
  }, []);

  return (
    <div className="editor-code">
      {children}
      <Editor
        height="400px"
        defaultLanguage="javascript"
        theme="vs-dark"
        onMount={handleEditorDidMount}
        onChange={(v) => onChange(v)}
      />
    </div>
  );
};

export { EditorCode };
